var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.uploadImage.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6 col-xs-12" },
                  [
                    _c("fg-image", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.small_image,
                          expression: "rules.small_image"
                        }
                      ],
                      attrs: {
                        type: "file",
                        label: "Select File and Upload",
                        "data-vv-name": "small image",
                        "cus-name": "small image",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      on: { file: _vm.updateSmallImg },
                      model: {
                        value: _vm.small_image,
                        callback: function($$v) {
                          _vm.small_image = $$v
                        },
                        expression: "small_image"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-fill btn-block",
                  attrs: {
                    type: "submit",
                    disabled: _vm.smallNewImage.length === 0
                  }
                },
                [_vm._v("\n            Upload\n          ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive text-center" },
        [
          _c(
            "l-table",
            {
              staticClass:
                "table table-light table-light table-bordered table-hover",
              attrs: { columns: _vm.imageColumns, data: _vm.imageList }
            },
            [
              _vm.imageList.length
                ? _c(
                    "template",
                    { slot: "table-row" },
                    _vm._l(_vm.imageList, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(item))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("img", {
                            staticClass: "table-thumbnail",
                            attrs: { src: item, alt: "event-image" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group",
                              attrs: { role: "group" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger btn-sm",
                                  on: {
                                    click: function($event) {
                                      return _vm.statusChange(item)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-toggle-off" })]
                              )
                            ]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row align-items-center mb-1" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "h2" }, [_vm._v("View/Upload Files")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a29427c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a29427c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/ImageUpload.vue
// module id = 6Ny3
// module chunks = 0